module.exports = __webpack_public_path__ + "media/arcade-done.e142a346.mp3";